import { Low } from '@ow/lowdb'
import lodash from 'lodash-es'

export default class LowWithLodash extends Low {
  get chain() {
    console.log('chain')
    return lodash.chain(this).get('data')
  }
}
